import React from 'react';
import { Box, Typography, Container, useTheme } from '@mui/material';

const Footer = () => {
  const theme = useTheme();

  const isDarkMode = theme.palette.mode === 'dark';
  const backgroundColor = isDarkMode ? '#121212' : '#f1f1f1';
  const textColor = isDarkMode ? '#ffffffcc' : '#333';

  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: 1,
        mt: 'auto',
        backgroundColor: backgroundColor,
        color: textColor,
        textAlign: 'center',
        borderTop: `1px solid ${isDarkMode ? '#333' : '#ccc'}`,
        position: 'fixed',
        bottom: 0,
        width: '100%',
      }}
    >
      <Container maxWidth="sm">
        <Typography variant="body2" fontWeight="500">
          © {new Date().getFullYear()} <span style={{color:'#00f26e'}}>Sushila Public School</span> , All rights reserved.
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
